import { createRoot } from "react-dom/client";
import { Suspense } from "react";
import App from "./App";
import "./index.css";
import "./i18n";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";

if (Capacitor.isNativePlatform()) {
    console.log('[MAIN] Registering raw deep link listeners at app boot');
    CapacitorApp.addListener('appUrlOpen', (data) => {
        console.log('[MAIN] RAW appUrlOpen FIRED:', data.url);
        (window as any)._lastRawDeepLink = data.url;
    });

    CapacitorApp.getLaunchUrl().then((result) => {
        console.log('[MAIN] RAW getLaunchUrl FIRED:', result?.url);
    });
}

// iOS Safari ignore user-scalable=no : on bloque le pinch-zoom via les gestes WebKit
document.addEventListener('gesturestart', (e) => e.preventDefault());

createRoot(document.getElementById("root")!).render(
    <Suspense fallback="Loading...">
        <App />
    </Suspense>
);
